const publicProject = [
	{
		name: "Kassen Website",
		web_link: "https://kassen.com.tw",
		thumbnail_url: "/thumbnails/kasen.com.tw.webp",
		category: "client_public",
		description:
			"A full redesign and redevelopment of the Kassen corporate website focused on improving visual identity, content management, product organization, and website performance. The project included rebuilding the entire website structure in WordPress, implementing dynamic product management features, optimizing server and hosting issues, and creating a scalable CMS experience for the client team.",
		shortDesc:
			"Full WordPress redesign with dynamic product management and performance optimization.",
		tags: [
			"wordpress",
			"php",
			"elementor",
			"advanced-custom-fields",
			"seo",
			"figma",
			"css",
			"javascript",
		],
		role: "WordPress Developer & Designer",
		year: "2025",
		confidentialNote: null,
		details: {
			overview:
				"Kassen is a corporate product website that required a complete redesign and structural rebuild. The client wanted to modernize the website, improve performance, reorganize product information, and create a more scalable content management workflow after facing multiple issues with the previous development setup.",
			problem:
				"The previous website suffered from outdated design, poor performance, unstable hosting/server access, and limited content management flexibility. Product resources such as drivers, certificates, manuals, and software downloads were difficult to organize, while the overall user experience did not properly represent the company’s brand and products.",
			solution:
				"I redesigned and rebuilt the website using WordPress, Elementor, ACF (Advanced Custom Fields), and custom code for features that could not be achieved efficiently with plugins alone. The website includes dynamic product management by category and product type, detailed product specification pages, downloadable resources, SEO optimization, support pages, partner pages, career pages, articles, and integrated live chat. I also handled UI/UX redesign work in Figma and helped resolve server and deployment-related issues caused by the previous infrastructure setup.",
			timeline: [
				{
					date: "Mar 2025",
					label: "UI/UX redesign & information architecture",
				},
				{
					date: "Apr 2025",
					label: "WordPress development & CMS implementation",
				},
				{
					date: "May 2025",
					label: "Product management system & optimization",
				},
				{
					date: "Jun 2025",
					label: "Revision cycles, deployment & launch",
				},
			],
			highlights: [
				"Complete website redesign from scratch",
				"Dynamic product management by category and product type",
				"Detailed product pages with specifications and downloadable resources",
				"Integrated drivers, manuals, certificates, and software downloads",
				"Custom CMS fields using Advanced Custom Fields (ACF)",
				"Performance optimization and hosting/server troubleshooting",
				"SEO optimization for product and article pages",
				"Integrated live chat functionality",
				"Responsive layouts across desktop and mobile devices",
				"Handled both design workflow and WordPress implementation",
			],
			outcome:
				"The final platform delivered a significantly more modern and scalable web presence for the client. Despite major revision cycles and changing stakeholder feedback during the project, the website was successfully launched with improved performance, better product organization, and a more maintainable CMS workflow for the internal team.",
		},
	},

	{
		name: "PT. Mesin Kasir Online Website Redesign",
		web_link: "https://ptmko.co.id",
		thumbnail_url: "/thumbnails/ptmko.co.id.webp",
		category: "client_public",
		description:
			"A full redesign and redevelopment project for PT. Mesin Kasir Online focused on improving website performance, modernizing the UI/UX, restructuring product content, and stabilizing hosting infrastructure. The project also included server migration, domain migration, and CMS optimization using WordPress.",
		shortDesc:
			"Corporate website redesign with server migration and CMS optimization.",
		tags: [
			"wordpress",
			"php",
			"elementor",
			"advanced-custom-fields",
			"cpanel",
			"seo",
			"figma",
			"css",
			"javascript",
		],
		role: "WordPress Developer & Designer",
		year: "2025",
		confidentialNote: null,
		details: {
			overview:
				"This project involved redesigning and rebuilding the PT. Mesin Kasir Online website to create a more modern, maintainable, and scalable digital presence. In addition to frontend redesign work, the project also required handling hosting infrastructure issues, server migration, and domain migration.",
			problem:
				"The previous website faced multiple issues including outdated design, inconsistent performance, hosting/server instability, and limited flexibility for managing product information. The client also experienced operational problems with their previous hosting setup and needed a smoother content management workflow for products and company resources.",
			solution:
				"I rebuilt the website using WordPress with Elementor and Advanced Custom Fields (ACF) to create a more flexible CMS structure. The platform supports categorized product management, detailed product pages, downloadable resources, article management, and SEO optimization. Beyond frontend development, I also handled server migration and domain migration using cPanel to ensure a more stable deployment environment and smoother website maintenance process.",
			timeline: [
				{
					date: "Mar 2025",
					label: "UI/UX redesign & project planning",
				},
				{
					date: "Apr 2025",
					label: "CMS architecture & WordPress development",
				},
				{
					date: "May 2025",
					label: "Product management system & optimization",
				},
				{
					date: "Jun 2025",
					label: "Server migration, deployment & launch",
				},
			],
			highlights: [
				"Complete corporate website redesign",
				"Custom WordPress CMS using Elementor and ACF",
				"Dynamic product and category management",
				"SEO optimization for articles and product pages",
				"Responsive design across desktop and mobile devices",
				"Server migration and domain migration using cPanel",
				"Improved hosting stability and deployment workflow",
				"Integrated downloadable product resources and documentation",
				"Custom-coded features beyond plugin limitations",
			],
			outcome:
				"The redesigned website provided the client with a more professional online presence, improved performance, and a scalable CMS workflow for long-term maintenance. The successful migration process also reduced infrastructure-related issues and improved overall website reliability.",
		},
	},

	{
		name: "Andira Genset Website",
		web_link: "https://andiragenset.com",
		thumbnail_url: "/thumbnails/andiragenset.com.webp",
		category: "client_public",
		description:
			"A corporate profile website developed for Andira Genset, a generator and power solutions company. The platform was designed to showcase the company’s services, product catalog, rental offerings, and industrial hardware solutions through a modern and responsive web experience.",
		shortDesc:
			"Corporate website and product catalog for a genset and power solutions company.",
		tags: [
			"wordpress",
			"php",
			"elementor",
			"css",
			"javascript",
			"seo",
			"responsive-design",
		],
		role: "WordPress Developer",
		year: "2023",
		confidentialNote: null,
		details: {
			overview:
				"This project was developed for Andira Genset, a company specializing in generator systems, rental services, electrical panels, and industrial hardware solutions. The goal was to build a professional company profile website that could present the company’s services and product offerings more effectively to potential clients.",
			problem:
				"The company needed a modern digital presence to better showcase their products, rental services, and technical capabilities. Their existing online presence lacked structured product information, professional presentation, and responsive user experience for customers browsing across devices.",
			solution:
				"I developed a responsive company profile website with a structured product catalog and service-focused pages. The platform highlights generator products, rental services, electrical panel solutions, and supporting company information. The website was optimized for usability, responsive layouts, and easier content management using WordPress.",
			timeline: [
				{
					date: "Oct 2023",
					label: "Project planning & design adaptation",
				},
				{
					date: "Oct 2023",
					label: "Website development & CMS setup",
				},
				{
					date: "Nov 2023",
					label: "Content integration & deployment",
				},
			],
			highlights: [
				"Responsive company profile website",
				"Structured product catalog system",
				"Service-focused landing pages",
				"Generator and industrial hardware showcase",
				"Rental and electrical panel information pages",
				"SEO-friendly content structure",
				"Optimized for desktop and mobile browsing",
				"WordPress-based content management workflow",
			],
			outcome:
				"The final website helped modernize the company’s online presence and provided a more professional platform for showcasing products and services to potential industrial and commercial clients.",
		},
	},

	{
		name: "TIK.R Media Platform",
		web_link: "https://tikr.my.id",
		thumbnail_url: "/thumbnails/tikr.my.id.webp",
		category: "client_public",
		description:
			"A modern media and article publishing platform developed for TIK.R. The website allows public users to submit articles while providing administrators with a moderation dashboard to review, edit, approve, or reject submissions before publication. The project focused heavily on redesigning the previous website into a more responsive and user-friendly platform.",
		shortDesc:
			"Media publishing platform with article moderation and admin workflow.",
		tags: [
			"php",
			"html",
			"css",
			"javascript",
			"mysql",
			"responsive-design",
			"cms",
		],
		role: "Fullstack Web Developer",
		year: "2026",
		confidentialNote: null,
		details: {
			overview:
				"TIK.R is a media and article publishing platform built to modernize the client’s previous website experience. The platform enables public article submissions while maintaining editorial control through an admin moderation system before content is published.",
			problem:
				"The client’s previous website had an outdated design, poor mobile responsiveness, and limited content management functionality. The platform also lacked a structured workflow for reviewing user-submitted articles, making content moderation inefficient and difficult to manage.",
			solution:
				"I rebuilt the platform using vanilla PHP, HTML, CSS, and JavaScript with a cleaner and more responsive design system. The website includes a public article submission flow where submitted content is sent to an admin dashboard instead of being published directly. Administrators can review, edit, approve, or reject articles before publication, creating a more controlled editorial workflow.",
			timeline: [
				{
					date: "Mar 2026",
					label: "Project planning & UI redesign",
				},
				{
					date: "Apr 2026",
					label: "Core CMS & moderation workflow development",
				},
				{
					date: "Apr 2026",
					label: "Responsive optimization & deployment",
				},
			],
			highlights: [
				"Public article submission system",
				"Admin moderation dashboard",
				"Approve, reject, and edit article workflow",
				"Responsive redesign for mobile and desktop",
				"Custom CMS built with vanilla PHP",
				"Improved content management structure",
				"Modernized UI compared to previous platform",
				"Lightweight architecture without heavy frameworks",
			],
			outcome:
				"The new platform provided the client with a cleaner, more professional media presence and a significantly improved editorial workflow. The responsive redesign also solved major usability issues on mobile devices and modernized the overall user experience.",
		},
	},

	{
		name: "Kassen Warranty Management System",
		web_link: "https://kassen-registrasi-garansi.vercel.app/check",
		thumbnail_url: "/thumbnails/kassen-registrasi-garansi.vercel.app.webp",
		category: "client_public",
		description:
			"An enterprise-grade warranty management platform developed for Kassen to manage product warranties, dealer operations, invoice tracking, and serial number validation. The system supports multiple user roles, public warranty checking, Excel-based product imports, audit logging, and automated notification workflows.",
		shortDesc:
			"Enterprise warranty and dealer management platform with public serial number verification.",
		tags: [
			"next.js",
			"typescript",
			"postgresql",
			"drizzle-orm",
			"better-auth",
			"tailwindcss",
			"tanstack-query",
			"tanstack-table",
			"xlsx",
			"nodemailer",
			"jest",
			"react-testing-library",
			"pino",
			"cpanel",
		],
		role: "Fullstack Developer",
		year: "2025",
		confidentialNote:
			"This is a private enterprise system developed for internal dealer and warranty operations. Public access and source code are restricted.",
		details: {
			overview:
				"This project was built for Kassen to centralize warranty management, dealer operations, and product tracking into a single platform. The system enables internal teams to manage product distribution, warranty validation, invoice workflows, and serial number records while also providing a public-facing warranty verification feature for customers.",
			problem:
				"The client previously handled warranty tracking and dealer management manually, making it difficult to validate product warranties, monitor product distribution, and maintain accurate warranty records across dealers. There was also no centralized system for public customers to verify warranty status independently.",
			solution:
				"I developed a fullstack warranty management platform using Next.js, TypeScript, PostgreSQL, and Drizzle ORM. The system supports four different user roles including dealers, technical support, sales, and administrators. Dealers can upload invoices and manage warranty submissions, while technical support teams can monitor warranty status, validate claims, and update warranty conditions. Excel import workflows were implemented using XLSX parsing to normalize serial number data into the database. Authentication was handled using Better Auth with OTP login and magic link verification flows. Public users can verify product warranties by entering serial numbers, and if data is unavailable they can submit support requests directly through the platform.",
			timeline: [
				{
					date: "Mar 2025",
					label: "Requirement analysis & system architecture",
				},
				{
					date: "Apr 2025",
					label: "Authentication, roles & database modeling",
				},
				{
					date: "May 2025",
					label: "Warranty workflows & dealer management",
				},
				{
					date: "Jun 2025",
					label: "Excel import system & public warranty checker",
				},
				{
					date: "Jul 2025",
					label: "Notifications, testing & deployment",
				},
			],
			highlights: [
				"Multi-role enterprise dashboard (dealer, technical support, sales, admin)",
				"Public warranty verification using serial numbers",
				"Excel upload and normalization workflow using XLSX",
				"Dealer invoice submission and tracking system",
				"Warranty validation and claim management",
				"OTP authentication and magic link verification using Better Auth",
				"Audit/event logging using Pino",
				"Advanced data tables with filtering and sorting",
				"Automated email notifications using Nodemailer",
				"PostgreSQL database with Drizzle ORM",
				"Unit and component testing using Jest and React Testing Library",
				"Deployed and managed using cPanel infrastructure",
			],
			outcome:
				"The platform significantly improved warranty management efficiency by centralizing dealer workflows, serial number validation, and customer warranty verification into a single system. It reduced manual tracking processes, improved transparency across departments, and created a more reliable after-sales support workflow for both internal teams and public customers.",
		},
	},
];

export default publicProject;
